import * as React from 'react'

const SvgChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 13.75L3.75 7.5l.875-.875L10 12l5.375-5.375.875.875L10 13.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronDownIcon
